import React, { useEffect, useState } from "react";
import { Navigate, Link } from "react-router-dom";
import { getStoredSession } from "../mmtUserList/mmtFlow";
import { fetchLoggedUserInfo } from "../mmtUserList/mmtApi";
import { useT } from "../../i18n/useT";
import MmtForgotPasswordFlow from "./MmtForgotPasswordFlow";

// The supported backend password operation is email verification + OTP reset.
export default function MmtChangePassword() {
  const [session] = useState(getStoredSession);
  const [email, setEmail] = useState(null);
  const [failed, setFailed] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const t = useT("population");
  const auth = useT("mmtForgot");
  useEffect(() => {
    if (!session) return;
    let cancelled = false;
    setFailed(false);
    fetchLoggedUserInfo(session)
      .then((info) => {
        if (cancelled) return;
        if (!info?.email) setFailed(true);
        else setEmail(info.email);
      })
      .catch(() => {
        if (!cancelled) setFailed(true);
      });
    return () => {
      cancelled = true;
    };
  }, [session, attempt]);
  if (!session) return <Navigate to="/login" replace />;
  if (!email)
    return (
      <main className="mmt-login-page">
        <div className="mmt-login-shell">
          <Link className="mmt-auth-back" to="/user-list">
            {t("Back")}
          </Link>
          <p role={failed ? "alert" : "status"}>
            {failed ? auth("error_generic") : t("Loading")}
          </p>
          {failed && (
            <button onClick={() => setAttempt((value) => value + 1)}>
              {t("Retry")}
            </button>
          )}
        </div>
      </main>
    );
  return <MmtForgotPasswordFlow changePassword accountEmail={email} />;
}
